<svg xmlns="http://www.w3.org/2000/svg" width="32" height="16" viewBox="0 0 32 16">
  <g fill="transparent" stroke="transparent">
    <rect width="32" height="16" stroke="none" rx="8"/>
    <rect width="31" height="15" x=".5" y=".5" fill="none" rx="7.5"/>
  </g>
  <path fill="#006dc9"
        d="M13 2a2 2 0 1 1 2 2 2 2 0 0 1-2-2zM7 2a2 2 0 1 1 2 2 2 2 0 0 1-2-2zM1 2a2 2 0 1 1 2 2 2 2 0 0 1-2-2z"
        transform="translate(7 6)"/>
</svg>
